<template>
    <div class="fst-QueryAnalysis" v-loading="loading">
        <!--el-checkbox label="Использовать сервис оценки" v-model="useQDCService"></el-checkbox-->
        <el-switch class="my-3"
                   v-model="useQDCService"
                   @change="handleToggleUseQDC"
                   active-text="Количественный анализ"
                   inactive-text="Анализ с разъяснениями">
        </el-switch>
        <el-form inline clss="params">
            <el-form-item label="Документы">
                <el-select v-model="docType">
                    <el-option label="Science Pro" value="Science"></el-option>
                    <el-option label="Crossref" value="ScienceCrossref"></el-option>
                    <el-option label="OpenAlex" value="ScienceOpenAlex"></el-option>
                    <el-option label="Patents" value="Patents"></el-option>
                    <el-option label="News" value="News"></el-option>
                </el-select>
                <el-input-number :step="docStep" class="ml-3"
                                 :min="10" :max="maxDocs" v-model="docCount"></el-input-number>
            </el-form-item>
            <el-form-item label="Зафиксировать набор">
                <el-checkbox v-model="pinSeed"></el-checkbox>
            </el-form-item>
            <el-form-item>
                <el-input v-model="seed" :disabled="!pinSeed"></el-input>
            </el-form-item>
            <el-form-item label="Выборка">
                <el-select v-model="sampleType">
                    <el-option label="декомпозиция запроса" value="randomPerElement"></el-option>
                    <el-option label="полностью случайная" value="random"></el-option>
                </el-select>
            </el-form-item>
            <el-button type="primary"
                       :disabled="!query || !validation"
                       @click="runAnalysis">Анализировать</el-button>
        </el-form>
        <el-tag size="medium" class="mb-3 mt-1" v-if="analysis.docsTotal">Найдено {{toFin(analysis.docsTotal)}}
        </el-tag>
        <el-table v-show="analysis.elements.length" :data="analysis.elements" class="resultTab" :stripe="true">
            <el-table-column sortable label="Термин">
                <template slot-scope="scope">
                    <el-link @click="handleTableSelect(scope.row)">{{ scope.row.query }}</el-link>
                </template>
            </el-table-column>
            <el-table-column sortable label="Упоминается, абс.ед(%)" prop="docsDiff">
                <template #default="scope">
                    {{toFin(scope.row.docsWithinQuery)}} ({{Math.round(scope.row.docsWithinQuery/analysis.docsTotal*100)}}%)
                </template>
            </el-table-column>
            <el-table-column sortable label="'Хороших' документов в выборке, абс.ед(%)" prop="goodPercent">
                <template #default="scope">
                    {{ toFin(scope.row.sampleGoodDocs) }}
                    <template v-if="scope.row.sampleGoodDocs > 0">({{ scope.row.goodPercent }}%)</template>
                </template>
            </el-table-column>
            <el-table-column sortable label="'Плохих' документов в выборке, абс.ед(%)" prop="badPercent">
                <template #default="scope">
                    {{ toFin(scope.row.sampleBadDocs) }}
                    <template v-if="scope.row.sampleBadDocs > 0"> ({{ scope.row.badPercent }}%)</template>
                </template>
            </el-table-column>
            <el-table-column align="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleTableSelect(scope.row)">Рассмотреть
                    </el-button>
                </template>
            </el-table-column>
            <!--            <el-table-column sortable label="docsDiff" prop="docsDiff"></el-table-column>-->
            <!--            <el-table-column sortable label="docsTotal" prop="docsTotal"></el-table-column>-->
        </el-table>
    </div>

</template>

<script>
    import QueryAnalysisDocList from "@/components/settings/QueryAnalysisDocList.vue";

    export default {
        name: 'QueryAnalysis',
        components: {QueryAnalysisDocList},
        props: {
            topic: {type: String},
            description: {type: String},
            query: {type: String},
            validation: {type: Boolean},
            configId: {type: [String, Number]},
        },

        computed: {},
        data() {
            return {
                useQDCService: false,
                seed: null,
                pinSeed: false,
                docCount: 1000,
                maxDocs: 1000,
                docStep: 100,
                sampleType: 'randomPerElement',
                docType: 'Science',
                loading: false,
                selectedElements: [],
                analysis: {
                    elements: [],
                    documents: {list: []},
                    docsTotal: 0,
                    docsTotalFormatted: ''
                },
                show: {
                    documents: false
                }

            }
        },
        mounted() {
        },
        methods: {
            runAnalysis() {
                this.$services.notionAssistant.queryAnalysis({
                    configId: this.configId,
                    query: this.query,
                    description: this.description,
                    topic: this.topic,
                    useQDCService: this.useQDCService,
                    docType: this.docType,
                    queryFields: ["title", "description"],
                    docCount: this.docCount,
                    sampleType: this.sampleType,
                    seed: this.pinSeed ? this.seed : null
                })
                    .prepare({target: this.$el})
                    .then(resp => {
                        let data = resp.data;
                        this.seed = data.request.seed;
                        let elements = data.elements.map(el => {
                            return {
                                ...el,
                                sampleGoodDocs: el.sampleDocs - el.sampleBadDocs,
                                badPercent: el.sampleDocs !== 0 ? Math.round(el.sampleBadDocs / el.sampleDocs * 10000) / 100 : 0,
                                goodPercent: el.sampleDocs !== 0 ? Math.round((el.sampleDocs - el.sampleBadDocs) / el.sampleDocs * 10000) / 100 : 0,
                                docs: []
                            }
                        });
                        this.analysis.elements = elements;
                        for (let doc of data.documents) {
                            // let elementNames = []
                            for (let eId of doc.matchedElements) {
                                let element = elements[eId];
                                element.docs.push(doc);
                                // elementNames.push(element.name)
                            }
                            // doc.matchedElements = elementNames;
                        }
                        this.analysis.documents = {offset: 0, total: data.docsTotal, list: data.documents};
                        this.analysis.docsTotal = data.docsTotal;

                    });
            },

            dialogDocuments(classificationFilter) {
                let selectedElements = this.selectedElements;
                let classificationPredicate;
                if (classificationFilter === "bad") {
                    classificationPredicate = function (doc) {
                        return doc.bad === true;
                    }
                } else if (classificationFilter === "good") {
                    classificationPredicate = function (doc) {
                        return doc.bad === false;
                    }
                } else {
                    classificationPredicate = function (doc) {
                        return true;
                    }
                }

                if (!selectedElements) {
                    return {list: this.analysis.documents.list.filter(classificationPredicate)}
                } else {
                    return {list: this.analysis.documents.list.filter(d => d.matchedElements.some(eid => selectedElements.indexOf(eid) >= 0) && classificationPredicate(d))}
                }
            },

            handleTableSelect(el) {
                this.loading = true;
                setTimeout(() => {
                    this.selectedElements = el ? [el.id] : []
                    this.$modal.dialog(QueryAnalysisDocList, {
                        title: el.query,
                        modalParams: {
                            width: 1000,
                        },
                        ':valueFn': this.dialogDocuments,
                        class: 'notionAnalysis'
                    })
                    setTimeout(() => {
                        this.loading = false;
                    }, 225)
                }, 150)
            },

            handleToggleUseQDC() {
                this.maxDocs = this.useQDCService ? 10000 : 1000
                this.docCount = this.useQDCService ? 1000 : 100
                this.docStep = this.useQDCService ? 100 : 10
            },
            toFin(x) {
                return this.$utils.toFin(x);
            }

        }
    }
</script>

<style lang="scss">
    .fst-QueryAnalysis {
        .params {
            display: flex;
            gap: 20px;
        }

        .resultTab {
            th {
                background: $iq-color-grey-ultra-light;
                padding: 6px 0;
            }
        }

        .el-button--mini {
            height: 26px !important;
        }
    }

    .fst-Admin.wrapper + #modals-container {
        .fst-SearchListItem {
            max-height: calc(100vh - 260px);
        }
    }
</style>